import React from 'react';
import {
    CounterInput,
    DropdownV2,
    noop,
    useDropdown,
    Text,
    DropDownV2Context,
    defaultDropDownV2Context
} from '@priority-software/priority-style-react';
import {TextTrigger} from './TextTrigger';
import {ruleDialogID} from '../../../../../../constants';
import {texts} from '../../../../texts';

type Props = {
    value: number;
    onChange: (value: number) => void;
    disabled?: boolean;
    unit: string;
};

const ddBodyStyle = {
    padding: 4
};

export const NumberDropdown = (props: Props) => {
    const {value, onChange, disabled, unit} = props;
    const contextAPI = useDropdown({onClose: noop});
    const {isOpen, openDropdown, closeDropdown} = contextAPI;

    return (
        <div style={{display: 'inline-flex'}}>
            <DropDownV2Context.Provider value={{...defaultDropDownV2Context, ...contextAPI}}>
                <DropdownV2
                    isOpen={isOpen}
                    onClose={closeDropdown}
                    onOpen={openDropdown}
                    usePortal
                    portalSelector={ruleDialogID}
                    trigger={<TextTrigger disabled={disabled} value={value} />}
                    eventTypes={['touchstart', 'mousedown']}
                >
                    <div style={ddBodyStyle}>
                        <Text skin="label-1" tag="div">
                            {texts.number_input_label} {unit}
                        </Text>
                        <CounterInput
                            skin="input"
                            value={value}
                            step={1}
                            minValue={0}
                            onChange={onChange}
                        />
                    </div>
                </DropdownV2>
            </DropDownV2Context.Provider>
        </div>
    );
};
